import React from "react"

import AwardsChips from "../components/AwardsChips"
import AwardRankingBanner from "../components/AwardsRankingBanner/AwardRankingBanner"
import DesktopHappiestWorkplacesForYouDiv from "../components/DesktopHappiestWorkplacesForYouDiv"
import SideCards from "../components/SideCards"
import SocialsBanner from "../components/SocialsBanner"
import { CustomBox, TableWrapper } from "../styles"
import HappiestCompaniesContent from "./happiestCompaniesContent"

export default function HappiestCompanies() {
  return (
    <CustomBox width={1 / 1} mx="auto">
      <AwardRankingBanner />
      <AwardsChips />
      <DesktopHappiestWorkplacesForYouDiv />
      <TableWrapper flexDirection={["column", "column", "row"]}>
        <HappiestCompaniesContent />
        <SideCards />
      </TableWrapper>
      <SocialsBanner />
    </CustomBox>
  )
}
